import React from 'react'
import './footer.css'

const Footer = () => {
    return (
        <div className='footer'>
            <p>Tesla © 2021</p>
            <p>Privacy & Legal</p>
            <p>Contact</p>
            <p>Careers</p>
            <p>News</p>
            <p>Engage</p>
            <p>Locations</p>
        </div>
    )
}

export default Footer
